import React, { useMemo, createContext } from 'react';
import { Layout, Grid, message } from 'antd';

import NavigationHeader from '../components/Header';

const { Content, Footer } = Layout;
const { useBreakpoint } = Grid;

export const MessageContext = createContext(null);

const NavigationLayout = ({ children }) => {
	const screens = useBreakpoint();
	const [messageApi, contextHolder] = message.useMessage();
	const contentStyles = useMemo(() => {
		if (screens.xxl) {
			return { padding: '27px 201px' };
		} else if (screens.xl || screens.lg) {
			return { padding: '27px 100px' };
		} else {
			return { padding: 10 };
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [screens]);

	return (
		<MessageContext.Provider value={messageApi}>
			{contextHolder}
			<Layout style={{ minHeight: '100vh' }}>
				<NavigationHeader />
				<Content style={contentStyles}>
					{children}
				</Content>
				<Footer style={{ textAlign: 'center', color: '#666666' }}>
					Copyright © School of Engineering, The Hong Kong University of Science and Technology. All rights reserved.
				</Footer>
			</Layout>
		</MessageContext.Provider>

	);
};

export default NavigationLayout;